import landingRedirects from './landing-redirects.json';

const esc = (literal: string) => literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Escape all RegExp metacharacters in a literal string.
 */
const pattern = new RegExp(
  Object.keys(landingRedirects)
    .sort((a, b) => b.length - a.length) // longest first
    .map(esc) // escape meta-chars
    .join('|'), // alternation
  'g' // global search
);

export const replaceLandingRedirects = (txt: string): string =>
  txt.replace(
    pattern,
    (matched) => (landingRedirects as { [key: string]: string })[matched]
  );
